import React, {useEffect, useRef, useState} from 'react';
import {Modal, TreeSelect, message} from 'antd';
import Helper from '../../func';

const MoveNode = ({node, nodes, projectId, treeData, onCancel, afterMove}) => {
    const sources = nodes || [node];
    const sourceIds = new Set(sources.map((item) => Number(item.node_id)));
    const [parentId, setParentId] = useState();
    const [saving, setSaving] = useState(false);
    const pending = useRef(false);
    const active = useRef(true);
    useEffect(() => () => { active.current = false; }, []);

    // Exclude the source subtree: neither the node nor a descendant can be its parent.
    const destinations = (items) => items
        .filter((item) => !sourceIds.has(Number(item.node_id)))
        .map((item) => ({
            title: Number(item.node_id) === 0 ? '项目根节点 /' : item.title,
            value: Number(item.node_id),
            key: item.key,
            children: item.children ? destinations(item.children) : undefined,
        }));

    const move = () => {
        if (pending.current) return;
        if (parentId === undefined || parentId === null) {
            message.error('请选择目标父节点');
            return;
        }
        pending.current = true;
        setSaving(true);
        const finish = () => {
            pending.current = false;
            setSaving(false);
        };
        Helper.http.post(Helper.serviceUrl('node/move'), {
            ...(nodes ? {node_ids: [...sourceIds]} : {node_id: Number(node.node_id)}),
            node_parent_id: parentId,
            project_id: Number(projectId),
        }, (res) => {
            if (!active.current) return;
            finish();
            if (!res.success) {
                message.error(res.msg || '移动失败');
                return;
            }
            message.success(res.msg || '节点已移动，ID保持不变');
            afterMove(parentId);
        }, (data) => {
            if (!active.current) return;
            finish();
            message.error(data.msg || data.message || '移动失败，请重试');
        });
    };

    return <Modal title={nodes ? '批量移动节点' : '移动节点'} visible onCancel={onCancel} onOk={move}
        okText="确认移动" cancelText="取消" confirmLoading={saving}
        okButtonProps={{disabled: parentId === undefined || parentId === null}}
        cancelButtonProps={{disabled: saving}} closable={!saving} maskClosable={!saving} keyboard={!saving}>
        <p>{nodes ? `已选 ${sources.length} 个节点` : `当前节点：${node.title}`}</p>
        {nodes && <div style={{maxHeight: 160, overflow: 'auto'}}>
            {sources.map((item) => <div key={item.node_id}>{item.title}</div>)}
        </div>}
        <p>移动后，节点将成为目标节点的子节点，已有子节点一起移动，所有节点 ID 和权限关联保持不变。</p>
        {nodes && <p>同时勾选父节点与子节点时，子节点跟随父节点移动，保留原有父子关系。</p>}
        <label htmlFor="move-node-parent">目标父节点</label>
        <TreeSelect id="move-node-parent" style={{width: '100%', marginTop: 8}}
            placeholder="请选择目标父节点" treeData={destinations(treeData)}
            value={parentId} onChange={setParentId} disabled={saving}
            showSearch treeNodeFilterProp="title" treeDefaultExpandedKeys={[0]}
            dropdownStyle={{maxHeight: 400, overflow: 'auto'}} />
    </Modal>;
};

export default MoveNode;
